// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tu-0";